/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = `<div class="swym-wishlist-grid">
{{#products}} 
<a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
<div class="swym-wishlist-image-wrapper">
<img alt="" class="swym-wishlist-image" src="{{iu}}">
</div>
<div class="swym-title swym-title-1">
{{dt}}
</div>
<span class="wishlist-detail">
<span>{{variantinfo}}</span>
-
<span>{{cu}}{{pr}}</span>
</span>
<span class="wishlist-action">
<button class="btn-primary hidden" id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
{{#isInCart}}in den Warenkorb{{/isInCart}}{{^isInCart}}in den Warenkorb{{/isInCart}}
</button>
<form method="post" action="/cart/add"  accept-charset="UTF-8"
class="form product-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
<input type="hidden" name="form_type" value="product">
<input type="hidden" name="utf8" value="✓">
<input type="hidden" name="id" value="{{epi}}">
<div class="product-form__buttons">
<button type="submit" name="add" class="product-form__submit btn-primary">
<span>In den Warenkorb</span> </button>
</div>
</form>
</span>
<span class="wishlist-remove">
<button  id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
ENTFERNEN
</button>
</span>
</a>
{{/products}}
</div>`;


let productCardMarkupEmpty = `
<div class="wishlist-empty w-full max-w-md ml-auto mr-auto text-center">
    <div class="wishlist-empty__desc text-paragraph font-light">
        Speichern Sie Ihre Lieblingshosen.
        Möchten Sie Ihre Lieblingshose speichern? Klicken Sie einfach auf das Herzsymbol und das Produkt wird hier angezeigt.
    </div>
    <div class="wishlist-empty__action mt-10">
        <a href="/" class="btn-primary inline-block">
            Weiter shoppen
        </a> 
    </div>
</div>
`;


function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
		variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
		console.log("Successfully added product to cart.", c);
	}, function(e) {
		console.log(e);
	});

}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi){
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
		console.log('products ', products.length)
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			return p;
		});
		if(products.length > 0) {
			var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
				products: formattedWishlistedProducts
			});
		}else {
			var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkupEmpty, {
				products: formattedWishlistedProducts
			});
		}
		if(wishlistContentsContainer){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else{
			console.log("Container not found, Wishlist Page element not found");
		}
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */